/** React Query keys for the workspace's product claim requests (DEV-756). */
export const claimRequestsQueryKeys = {
  /** Prefix: all claim request caches. */
  root: ['claim-requests'] as const,
  list: (workspaceId: string | null | undefined) =>
    ['claim-requests', workspaceId ?? null] as const,
  /** Nav badge count (DEV-802). Under `list`, so list invalidations hit it. */
  count: (workspaceId: string | null | undefined) =>
    ['claim-requests', workspaceId ?? null, 'count'] as const,
} as const;
